import React from 'react';
import { HandshakeIcon, MailIcon } from 'lucide-react';
export function PartnersCallout() {
  return <section className="bg-black py-16 px-6" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <div className="relative bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-600/30 rounded-2xl p-8 md:p-12 shadow-2xl shadow-yellow-600/10" data-id="element-130">
          {/* Decorative corner accents */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-yellow-600 rounded-tl-2xl" data-id="element-131"></div>
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-yellow-600 rounded-br-2xl" data-id="element-132"></div>

          <div className="relative z-10 text-center" data-id="element-133">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-600/20 rounded-full mb-6" data-id="element-134">
              <HandshakeIcon className="w-8 h-8 text-yellow-400" data-id="element-135" />
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-136">
              ¿Quieres ser parte de{' '}
              <span className="bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent" data-id="element-137">
                SamboCard
              </span>
              ?
            </h2>

            <p className="text-gray-300 text-lg mb-6 max-w-2xl mx-auto" data-id="element-138">
              Si eres comercio, institución o tienes un emprendimiento y quieres
              ofrecer beneficios, contáctanos
            </p>

            <a href="mailto:aliados@sambocard.com" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-yellow-600 to-yellow-500 text-black font-bold text-lg rounded-lg hover:from-yellow-500 hover:to-yellow-400 transition-all transform hover:scale-105 shadow-lg shadow-yellow-600/30" data-id="element-139">
              <MailIcon className="w-5 h-5" data-id="element-140" />
              aliados@sambocard.com
            </a>
          </div>
        </div>
      </div>
    </section>;
}